module.exports = __webpack_public_path__ + "img/42071507.8981579e.png";